export default {
  avatar: require('../../../shared/styles/common/avatar.module.css').default,
  button: require('../../../shared/styles/common/button.module.css').default,
  dialog: require('../../../shared/styles/common/dialog.module.css').default,
  popup: require('../styles/common/popup.module.css').default,
  targetDialog: require('../styles/common/dialog.module.css').default,
  text: require('../../../shared/styles/common/text.module.css').default,
};
